// src/constants/siteSearchIndex.js
// #37 follow-up (operator request 2026-08-04): client-side static index of
// site pages/features for the storefront search "Pages" group. Purely
// local — no backend call; renders instantly while API groups load.
//
// EVERY path below is verified against a real route in src/App.js.
// Routes that DON'T exist and were therefore omitted/mapped:
//   - '/contact': no such route — contact intent maps to About Us keywords.
//   - bare '/account': no such route — account-hub intent maps to My Orders.
//   - FroggyAI is a full-page route (/account/froggy-chat, with /froggy-ai
//     as a redirect alias), not a widget launcher — linked directly.

export const SITE_SEARCH_INDEX = [
  {
    label: 'My Orders',
    path: '/account/orders',
    keywords: ['orders', 'order history', 'my orders', 'track', 'tracking', 'account'],
  },
  {
    label: 'Ask FroggyAI',
    path: '/account/froggy-chat',
    keywords: ['froggy', 'ai', 'help', 'advice', 'ask', 'chat', 'assistant'],
  },
  {
    label: 'Cart',
    path: '/cart',
    keywords: ['cart', 'basket', 'checkout'],
  },
  {
    label: 'Care Guides',
    path: '/care-guides',
    keywords: ['care', 'guides', 'guide', 'husbandry', 'setup'],
  },
  {
    label: 'Frogs',
    path: '/frogs',
    keywords: ['frogs', 'frog', 'available', 'dart frogs'],
  },
  {
    label: 'Geckos',
    path: '/geckos',
    keywords: ['geckos', 'gecko'],
  },
  {
    label: 'Plants',
    path: '/plants',
    keywords: ['plants', 'plant', 'terrarium'],
  },
  {
    label: 'FAQ',
    path: '/faq',
    keywords: ['faq', 'questions', 'question', 'answers'],
  },
  {
    label: 'About Us',
    path: '/about',
    keywords: ['about', 'contact', 'who we are', 'story'],
  },
  {
    label: 'Shipping Policy',
    path: '/shipping-policy',
    keywords: ['shipping', 'policy', 'delivery', 'live arrival'],
  },
];

/**
 * Match query tokens against label + keywords (case-insensitive substring;
 * every token must hit). Returns top `limit` pages.
 */
export const searchSitePages = (query, limit = 3) => {
  const q = (query || '').trim().toLowerCase();
  if (q.length < 2) return [];
  const tokens = q.split(/\s+/).filter(Boolean);
  return SITE_SEARCH_INDEX.filter((page) => {
    const haystack = `${page.label} ${page.keywords.join(' ')}`.toLowerCase();
    return tokens.every((t) => haystack.includes(t));
  }).slice(0, limit);
};
